import React, {Fragment} from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link
} from '@mui/material';

const data = [
  {
    id: 1,
    district: 'Shimla',
    planningAreas: [
      { name: 'Shimla', url: 'https://tcp.hp.gov.in/Application//uploadDocuments/devlopmentPlan/PlanDoc020150127_173301.pdf' },
      { name: 'Rampur', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Rampur_Planning_Area.pdf' },
      { name: 'Rohru', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Rohru_Planning_Area.pdf' },
      { name: 'Theog', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Theog_Planning_Area.pdf' },
      { name: 'Chopal', url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/Chopal-Rajpatra.pdf' },
      { name: 'Narkanda', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Narkanda_Planning_Area.pdf' },
      { name: 'Suni', url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_1.pdf' },
      { name: 'Kotkhai', url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_2.pdf' },
      { name: 'Jubbal', url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_3.pdf' },
    ],
    specialAreas: [
      { name: 'Hatkoti', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Hatkoti_Special_Area.pdf' },
      { name: 'Sarahan', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Sarahan_Special_Area.pdf' },
      { name: 'Shoghi', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Shoghi_Special_Area.pdf' },
      { name: 'Kufri', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Kufri_Special_Area.pdf' },
      { name: 'Ghanahatti', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Ghanahatti_Special_Area.pdf' },
    ],
  },
  {
    id: 2,
    district: 'Solan',
    planningAreas: [
      { name: 'Kasauli', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Kasauli_Planning_Area.pdf' },
      { name: 'Parwanoo', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Parwanoo_Planning_Area.pdf' },
      { name: 'Solan', url: 'https://tcp.hp.gov.in/Application//uploadDocuments/devlopmentPlan/PlanDoc020150127_180216.pdf' },
      { name: 'Waknaghat', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Waknaghat_Planning_Area.pdf' },
      { name: 'Hinner', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/notification_Hinner_Planning_Area.pdf' },
      { name: 'Arki', url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_4.pdf' },
    ],
    specialAreas: [
      { name: 'Kandaghat', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Kandaghat_Special_Area.pdf' },
      { name: 'Barog', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Barog_Special_Area.docx' },
      { name: 'Jabli', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Jabli_Special_Area.pdf' },
      { name: 'Harat', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Harat_Special_Area.pdf' },
      { name: 'Chail', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Chail_Special_Area.pdf' },
      { name: 'Baddi-Barotiwala-Nalagarh', url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Baddi-Barotiwala_Special_Area.pdf' },
    ],
  },
  {
    id: 3,
    district: "Sirmour",
    planningAreas: [
      { name: "Nahan", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Nahan_Planning_Area.pdf" },
      { name: "Paonta-Sahib", url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Paonta_Sahib_Special_Area_1.pdf" },
      { name: "Sangrah", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Sangrah_Planning_Area.pdf" },
      { name: "Dhaulakuan-Majra", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Dhaulakuan-Majra.pdf" },
      { name: "Rajgarh", url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_5.pdf" },
    ],
    specialAreas: [
      { name: "Paonta Sahib", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Paonta_Sahib_Special_Area.pdf" },
      { name: "Trilokpur", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Trilokpur_Special_Area.pdf" },
      null, // Sangrah has no special area
      null, // Dhaulakuan-Majra has no special area
      null, // Rajgarh has no special area
    ],
  },
  {
    id: 4,
    district: "Bilaspur",
    planningAreas: [
      { name: "Bilaspur", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Bilaspur_Planning_Area.pdf" },
      { name: "Ghumarwin", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Ghumarwin_Planning_Area.pdf" },
      { name: "Naina Devi", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Naina_Devi_Planning_Area.pdf" },
      { name: "Jhandutta", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Jhandutta_Planning_Area.pdf" },
      { name: "Sri Naina Deviji", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Sri_Naina_Deviji_Planning_Area.pdf" },
    ],
    specialAreas: [
      { name: "Paonta-Sahib", url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Paonta_Sahib_Special_Area_1.pdf" },
      null, // Ghumarwin has no special area
      null, // Naina Devi has no special area
      null, // Jhandutta has no special area
      { name: "Trilokpur", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Trilokpur_Special_Area.pdf" },
    ],
  },
  {
    id: 4,
    district: "Bilaspur",
    planningAreas: [
      { name: "Bilaspur", url: "https://www.tcp.hp.gov.in/Application//uploadDocuments/notification/Notice20160719_110831.pdf" },
      { name: "Ghumarwin", url: "https://www.tcp.hp.gov.in/Application//uploadDocuments/notification/Notice20160719_111108.pdf" },
      { name: "Sh. Naina Devi Ji.", url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_6.pdf" },
    ],
    specialAreas: [
      null, // Bilaspur has no special area
      null, // Ghumarwin has no special area
      null, // Sh. Naina Devi Ji. has no special area
    ],
  },
  {
    id: 5,
    district: "Una",
    planningAreas: [
      { name: "Una", url: null },
      { name: "Mehatpur", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Mehatpur_Planning_Area.pdf" },
      { name: "Amb-Gagret", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Amb-Gagret_Planning_Area.pdf" },
      { name: "Tahliwal", url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_7.pdf" },
      { name: "Daulatpur", url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_8.pdf" },
      { name: "Santokgarh", url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_9.pdf" },
    ],
    specialAreas: [
      { name: "Una", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Una_Special_Area.pdf" },
      { name: "Chintpurni", url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Sri_Chintpurni_Special_Area.pdf" },
      null, // Amb-Gagret has no special area
      null, // Tahliwal has no special area
      null, // Daulatpur has no special area
      null, // Santokgarh has no special area
    ],
  },
  {
    id: 6,
    district: "Hamirpur",
    planningAreas: [
      { name: "Hamirpur", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Hamirpur_Planning_Area.pdf" },
      { name: "Nadaun", url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Notification_Naduan.pdf" },
      { name: "Sujanpur", url: "https://www.tcp.hp.gov.in/Application//uploadDocuments/notification/Notice20160719_111241.pdf" },
      { name: "Bhota", url: "https://www.tcp.hp.gov.in/Application//uploadDocuments/notification/Notice20160719_111014.pdf" },
    ],
    specialAreas: [
      { name: "Baba Balak Nath", url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Baba_Balak_Nath_Special_Area.pdf" },
      null, // Nadaun has no special area
      null, // Sujanpur has no special area
      null, // Bhota has no special area
    ],
  },

  // Add other districts similarly...
];

const NotifiedAreasTable = () => {
  return (
    <Fragment>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Sr. No.</TableCell>
            <TableCell>District</TableCell>
            <TableCell>Planning Areas</TableCell>
            <TableCell>Special Areas</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            row.planningAreas.map((planningArea, index) => (
              <TableRow key={`${row.id}-${index}`}>
                {index === 0 && (
                  <>
                    <TableCell rowSpan={row.planningAreas.length}>{row.id}</TableCell>
                    <TableCell rowSpan={row.planningAreas.length}>{row.district}</TableCell>
                  </>
                )}
                <TableCell>
                  <Link href={planningArea.url} target="_blank" rel="noopener">{planningArea.name}</Link>
                </TableCell>
                <TableCell>
                  {row.specialAreas[index] ? (
                    <Link href={row.specialAreas[index].url} target="_blank" rel="noopener">
                      {row.specialAreas[index].name}
                    </Link>
                  ) : '-'}
                </TableCell>
              </TableRow>
            ))
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Fragment>
  );
};

export default NotifiedAreasTable;
